import { OtpChannel } from '../modules/account/_types/otp.types';

export interface ChannelConfig {
  value: OtpChannel;
  label: string;
  displayName: string;
}

export interface ValidationChannelConfig {
  channels: ChannelConfig[];
  defaultChannel?: OtpChannel;
}

const CHANNEL_LABEL_MAP: Record<OtpChannel, { displayName: string; getLabel: (contact: string) => string }> = {
  email: {
    displayName: 'E-mail',
    getLabel: (email) => `E-mail para ${email}`
  },
  sms: {
    displayName: 'SMS',
    getLabel: (phone) => `SMS para ${phone}`
  },
  whatsapp: {
    displayName: 'WhatsApp',
    getLabel: (phone) => `WhatsApp para ${phone}`
  }
};

export const otpRequestChannelTypeMapper = {
  /**
   * Mapeia o array de OtpChannel disponíveis para ChannelConfig,
   * filtrando canais cujo dado do usuário não está disponível.
   */
  getAvailableChannels: (
    validationType: OtpChannel[],
    userData: { phoneNumber?: string; email?: string }
  ): ValidationChannelConfig => {
    const { phoneNumber, email } = userData;

    const channels: ChannelConfig[] = validationType
      .map((channel) => {
        const config = CHANNEL_LABEL_MAP[channel];

        if (!config) return null;

        const contact = channel === 'email' ? email : phoneNumber;

        if (!contact) return null;

        return {
          value: channel,
          label: config.getLabel(contact),
          displayName: config.displayName
        };
      })
      .filter((c): c is ChannelConfig => c !== null);

    // Fallback: se nenhum canal do schema tem dados do usuário
    // mas ele possui e-mail, oferece e-mail como alternativa
    if (channels.length === 0 && email) {
      const emailConfig = CHANNEL_LABEL_MAP.email;

      channels.push({
        value: 'email',
        label: emailConfig.getLabel(email),
        displayName: emailConfig.displayName
      });
    }

    return {
      channels,
      defaultChannel: channels[0]?.value
    };
  },

  /**
   * Determina a pergunta baseada no número de canais disponíveis
   */
  getSecurityCodeQuestion: (channelsCount: number): string => {
    if (channelsCount === 0) {
      return 'Nenhum canal de validação disponível.';
    }

    if (channelsCount === 1) {
      return 'Você quer receber seu código de acesso aqui?';
    }

    return 'Por onde quer receber seu código de acesso?';
  }
};
